import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as CloseIcon } from '@elementary/common-ui/assets/close-2.svg';
import { Flex, TextField } from '@elementary/common-ui/components';
import { Chip, SxProps } from '@mui/material';

const ChipStyled = styled(Chip)`
  &.MuiChip-root {
    background: ${({ theme }) => theme.palette.common.gray9};
    border-color: ${({ theme }) => theme.palette.common.lightBlue3};
    border-radius: 100px;
    padding: 4px 4px 4px 6px;
  }
  .MuiChip-label {
    font-size: 12px;
    padding: 0;
    padding-right: 12px;
  }
`;

const CloseIconStyled = styled(CloseIcon)`
  height: 10px;
  width: 10px;
`;

type Props = {
  value?: string;
  onChange: (val: string) => void;
  placeholder?: string;
  textFieldSx?: SxProps;
};

const ChipInput = React.forwardRef(
  ({ value, onChange, placeholder, textFieldSx }: Props, ref: any) => {
    const [editMode, setEditMode] = useState<boolean>(true);
    const [typedValue, setTypedValue] = useState<string>('');

    const inputRef = useRef<any>();

    const handleKeyDown = (e: any) => {
      if (e.key === 'Enter' && typedValue.trim().length > 0) {
        setTypedValue('');
        setEditMode(false);
        onChange(typedValue);
      }
    };

    const handleBlur = () => {
      if (typedValue.trim().length > 0) {
        setTypedValue('');
        setEditMode(false);
        onChange(typedValue);
      }
    };

    return (
      <Flex sx={{ height: '40px', alignItems: 'center' }} ref={ref}>
        {editMode ? (
          <TextField
            sx={textFieldSx}
            value={typedValue}
            onChange={(e) => setTypedValue(e.target.value)}
            inputRef={inputRef}
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
            placeholder={placeholder}
          />
        ) : (
          <ChipStyled
            variant="outlined"
            label={value}
            deleteIcon={<CloseIconStyled />}
            onDelete={() => {
              onChange('');
              setEditMode(true);
              inputRef.current?.focus();
            }}
          />
        )}
      </Flex>
    );
  },
);

export default ChipInput;
